// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__15Z1C","footer":"ModalCreateQualiphyProcedure_footer__37z1m","additionData":"ModalCreateQualiphyProcedure_additionData___MLc7"};